import FlightOffer from "shared/types/flightOffer";

export function getRefsForFlightOffer(
  flightOffer: FlightOffer,
  selectedFlightOptions: string[]
) {
  const brand = selectedFlightOptions[0];
  return flightOffer.FlightCombinations.find(
    (fc) =>
      fc.UniformBrandName === brand &&
      fc.FlightOptionCombinations?.FlightOptionCombination.map(
        (foc) => foc.Key
      ).join("-") === selectedFlightOptions.slice(1).join("-")
  )?.References?.Reference.map((ref) => ref.$t);
}

export function getDefaultOptions(combinations) {
  const defaultOptions = [];

  const brandName = Object.keys(combinations)[0];
  defaultOptions.push(brandName);
  combinations[brandName]?.[0]?.map((foc) => defaultOptions.push(foc.Key));

  return defaultOptions;
}

export function getOptions(combinations, flightIndex, selected) {
  const selectedBrandName = selected[0];
  const options = [];

  combinations[selectedBrandName].forEach((foc) => {
    if (foc[flightIndex]?.Key) {
      if (!options.includes(foc[flightIndex].Key)) {
        options.push(foc[flightIndex].Key);
      }
    }
  });

  return options;
}
